import { StandardEvents } from '@shopify/events';

const pending = new WeakMap();

document.addEventListener(StandardEvents.productSelect, async event => {
  if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
  const section = event.target.closest('.shopify-section, dialog');
  if (!section?.querySelector('.wf-product-guide')) return;
  const request = event.promise;
  pending.set(section, request);
  try {
    const { detail } = await request;
    if (pending.get(section) !== request || !section.isConnected) return;
    // The material row links to the other finish in the size that is selected now.
    const updated = detail?.html?.querySelector('[data-wf-material-link]');
    if (updated) section.querySelectorAll('[data-wf-material-link]').forEach(link => link.setAttribute('href', updated.getAttribute('href')));
  } catch (error) {
    if (error?.name !== 'AbortError') console.warn('[wf-product-guide]', error);
  }
});
